module.exports = __webpack_public_path__ + "static/me-156b82c17b3866fd946ef985ae28624b.png";